import { render, staticRenderFns } from "./marsMedicationModal.vue?vue&type=template&id=52f880e2&scoped=true&"
import script from "./marsMedicationModal.vue?vue&type=script&lang=js&"
export * from "./marsMedicationModal.vue?vue&type=script&lang=js&"
import style0 from "./marsMedicationModal.vue?vue&type=style&index=0&id=52f880e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f880e2",
  null
  
)

export default component.exports